export enum VerifyEmailStatus {
  Expired = 'Expired',
  Failed = 'Failed',
  Success = 'Success'
}
